var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-center"},[_c('h1',{staticClass:"title"},[_vm._v("可视化数据监测大屏")])])
}]

export { render, staticRenderFns }